import { ActionItemWrapper } from '@anm/components/ActionsDropdown';
import { Item } from '@anm/components/ActionsDropdown/ActionItem';
import { FC } from 'react';
import styled from 'styled-components';

import DuplicateUpgradeTooltip, { DuplicateUpgradeTooltipProps } from '../DuplicateUpgradeTooltip';

const Wrapper = styled(ActionItemWrapper)`
  && > a,
  && span {
    padding-left: 48px !important;
  }
`;

type DuplicateActionProps = DuplicateUpgradeTooltipProps & {
  shouldUpgrade: boolean;
};

const DuplicateAction: FC<DuplicateActionProps> = ({ action, handler, shouldUpgrade }) => (
  <Wrapper as="div" {...action} onClick={shouldUpgrade ? undefined : handler}>
    {shouldUpgrade ? <DuplicateUpgradeTooltip {...{ action }} /> : <Item {...action} />}
  </Wrapper>
);

export default DuplicateAction;
